export const APPLY_STATUS = {
    APPLY_INFO: 2, // 个人资料填写
    APPLY_MOBILE_VALID: 4, // 手机验证
    APPLY_BANK_VALID: 5, // 银行卡验证
    APPLY_ZHIMA_VALID: 6, // 芝麻授权
    APPLY_BANK_VALID2: 7, // 银行卡验证
    APPLY_OCR_VALID: 14, // 身份证照片上传
    APPLY_OCR_VALID_ING: 15, // 身份证照片比对中
    APPLY_BASIC_INFO: 25, // 基本信息
    APPLY_PERSON_INFO: 26, // 个人信息
    CREDIT_LINE: 1001, // 授信额度
    BIND_CARD: 3005, // 支用流程绑卡
    APPLY_IDENTITY_VALID: 1016, //身份证上传页面
    APPLY_SUPPLEMENT_VALID: 1029 //增信页面
}
export const APPLY_DL_STATUS = {
    APPLY_FAILED: 2, // 申请失败
    APPLY_VENDOR: 29, // 补充数据
    APPLY_UPLOAD_PHOTO: 16, // 身份证正反面
    APPLY_UPLOAD_FACE: 42, // 需要上传自拍照
    APPLY_MOBILE: 43, // 需要获取话单
    APPLY_BANK: 40, // 需要绑卡
    APPLY_CHECK: 17, // 等待页面
    APPLY_SIGN: 18, // 可以签约
    APPLY_SIGNING: 28, // 提交签约
    APPLY_LOANING: 10 // 导流资金放款中
}
export const USER_STATUS = {
    LOAN_APPLY: 2, // 可借款
    DLXJ_LOAN_APPLY: 9, // 导流现金可借款
    QUOTA_APPLY: 3, //可申请额度
    QUOTA_APPLY_ING: 4, //额度申请中
    QUOTA_CREDIT: 5, //额度授信中 (授信获取额度成功，需要上传身份证)
    CREDIT_FAIL: 6, //授信被拒绝
    QUOTA_APPLY_FAIL: 10, //支用被拒绝
    TMP_QUOTA_CREDIT: 7, //可激活临时额度 ， 预授信用户
    TMP_QUOTA_CREDIT_ING: 8 //临时额度激活中 ， 预授信用户
}
export const PROJECT_STATUS = {
    DRAFT: -1, // 草稿状态, 未上标
    INIT: 0, // 初始化
    FINANCING: 1, // 融资中
    REPAYING: 2, // 还款中
    STOP: 3, // 已终止
    FINISH: 4, // 已结束
    OVERDUE: 5 // 已逾期
}
export default {
    APPLY_STATUS,
    APPLY_DL_STATUS,
    USER_STATUS,
    PROJECT_STATUS
}